import { Flex, Stack } from '@chakra-ui/react'
import React from 'react'
import BlogCardItem from './blog-card-item'
import { IBlogItem } from '@common/interface/blog'

interface PropsType {
  blogItems: IBlogItem[]
}

const Blogs = ({ blogItems }: PropsType) => {
  const displayBlogItems = () => {
    return blogItems.map((item) => {
      return <BlogCardItem key={item.id} item={item} />
    })
  }

  return (
    <Flex justify={'center'}>
      <Stack spacing={10} w={'100%'}>
        {displayBlogItems()}
      </Stack>
    </Flex>
  )
}

export default Blogs
